export default __webpack_public_path__ + "static/media/coconut.87295dbf.jfif";